import React, { useCallback, useContext } from 'react';
import { AuthContext } from 'src/hooks/useAuth';
import { Container, Logout, UserInfo, Buttons } from './styles';
import { FaUserCircle } from 'react-icons/all';
import { Link, NavLink, useRouteMatch } from 'react-router-dom';
import Button from 'src/components/Button';

type Props = {
  buttonTab1?: string,
  buttonTab2?: string,
  buttonTab3?: string,
  buttonTab4?: string;
  pathRouteTab1?: string,
  pathRouteTab2?: string,
  pathRouteTab3?: string,
  pathRouteTab4?: string;
}

const Header = (
  {
  buttonTab1 = 'Relatório',
  buttonTab2 = 'Veículos',
  buttonTab3 = 'Colaboradores',
  pathRouteTab1 = '/frotas',
  pathRouteTab2 = '/veiculos',
  pathRouteTab3 = '/colaboradores',
  }
:Props) => {
  const { user, logout } = useContext(AuthContext);
  const isRoute = useRouteMatch(['/frotas', '/veiculos', '/colaboradores']);

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  return (
    <Container>
      <Buttons>
       <Button as={NavLink} to={pathRouteTab1} fill={(isRoute?.path === pathRouteTab1)} size='sm'>
         {buttonTab1}
       </Button>
       <Button as={NavLink} to={pathRouteTab2} fill={(isRoute?.path === pathRouteTab2)} size='sm'>
       {buttonTab2}
       </Button>
       <Button as={NavLink} to={pathRouteTab3} fill={(isRoute?.path === pathRouteTab3)} size='sm'>
       {buttonTab3}
       </Button>
      </Buttons>
      <UserInfo>
        <FaUserCircle /> {user?.fullName}
      </UserInfo>
      <Logout>
        <Link to='/login' onClick={handleLogout}>
          Sair
        </Link>
      </Logout>
    </Container>
  );
};

export default Header;
